export enum TextDecoration {
  None = 'none',
  LineThrough = 'line-through',
  Overline = 'overline',
  Underline = 'underline'
}
